/* eslint-disable camelcase */
import React from 'react';
import { Headline, Details, HeaderImage, ContentTruncated } from '../../atoms';
import { Heading } from '../../../../slices/atoms';
import {
  styledFeaturedBlogTitle,
  StyledBlogListContent,
  StyledFeaturedBlogContainer,
  StyledBlogTextContent,
} from './FeaturedBlogPostsStyles';

const renderBlogPost = (
  blog_header_image,
  blog_headline,
  blog_post_date,
  blog_post_content,
  author,
  tags,
  uid,
  isFirst,
) => {
  return (
    <StyledBlogListContent className={isFirst ? 'first-blog-post featured-blog-post' : 'featured-blog-post'}>
      {isFirst && (
        <Heading className="h2 darkblue" css={styledFeaturedBlogTitle}>
          Featured posts
        </Heading>
      )}
      {HeaderImage(blog_header_image, null, 'featured-image')}
      <StyledBlogTextContent>
        {Details(author, tags, blog_post_date, 'bloglist is-hidden-mobile featured')}
        {Headline(blog_headline, uid, 'bloglist featured')}
        {ContentTruncated(blog_post_content, 'featured', 120)}
      </StyledBlogTextContent>
    </StyledBlogListContent>
  );
};

const FeaturedBlogPosts = data => {
  const {
    featured_blog_1,
    featured_blog_2,
    featured_blog_3,
    featured_blogs_enabled,
  } = data.prismic.allFeaturedblogs.edges[0].node;

  if (!featured_blogs_enabled) return null;
  return (
    <StyledFeaturedBlogContainer>
      {featured_blog_1 &&
        renderBlogPost(
          featured_blog_1.blog_header_image,
          featured_blog_1.blog_headline,
          featured_blog_1.blog_post_date,
          featured_blog_1.blog_post_content,
          featured_blog_1.author,
          featured_blog_1.tags,
          featured_blog_1._meta.uid,
          true,
        )}
      {featured_blog_2 &&
        renderBlogPost(
          featured_blog_2.blog_header_image,
          featured_blog_2.blog_headline,
          featured_blog_2.blog_post_date,
          featured_blog_2.blog_post_content,
          featured_blog_2.author,
          featured_blog_2.tags,
          featured_blog_2._meta.uid,
        )}
      {featured_blog_3 &&
        renderBlogPost(
          featured_blog_3.blog_header_image,
          featured_blog_3.blog_headline,
          featured_blog_3.blog_post_date,
          featured_blog_3.blog_post_content,
          featured_blog_3.author,
          featured_blog_3.tags,
          featured_blog_3._meta.uid,
        )}
    </StyledFeaturedBlogContainer>
  );
};

export default FeaturedBlogPosts;
